module.exports = __webpack_public_path__ + "img/student-walking-stairs.f873502d.jpg";